/* Load only the five lower homepage product rows as they approach view. */
(function () {
  'use strict';

  var rows = Array.from(document.querySelectorAll('[data-spike-deferred-home-row]'));
  if (!rows.length) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    (window.routes && window.routes.root) || '/';
  root = root.replace(/\/*$/, '/');

  function fallback(row) {
    var track = row.querySelector('.spike-carousel__track');
    var section = row.closest('.trending-product');
    var original = section && section.querySelector('.view_all[href]');
    var link = document.createElement('a');
    link.href = original ? original.href : root + 'collections/' + encodeURIComponent(row.dataset.collectionHandle);
    link.textContent = original ? original.textContent.trim() : 'View collection';
    track.replaceChildren(link);
    row.removeAttribute('data-spike-deferred-home-row');
  }

  function load(row) {
    if (row.dataset.spikeHomeLoading) return;
    row.dataset.spikeHomeLoading = 'true';
    var url = root + 'collections/' + encodeURIComponent(row.dataset.collectionHandle) + '?view=spike-home-row';
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Homepage row: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var fragment = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.from(fragment.querySelectorAll('body > .product'));
        if (!cards.length || cards.length > 10) throw new Error('Homepage row: invalid card response');
        row.querySelector('.spike-carousel__track').replaceChildren.apply(
          row.querySelector('.spike-carousel__track'), cards
        );
        if (window.Currency && window.sharedFunctions &&
            window.sharedFunctions.checkNeedToConvertCurrency &&
            window.sharedFunctions.checkNeedToConvertCurrency()) {
          var active = document.querySelector('#currencies .active');
          if (active && active.dataset.currency) {
            window.Currency.convertAll(window.shop_currency, active.dataset.currency,
              '[data-spike-deferred-home-row] span.money', 'money_format');
          }
        }
        row.removeAttribute('data-spike-deferred-home-row');
        delete row.dataset.spikeHomeLoading;
        if (window.spikeProductCarouselScan) window.spikeProductCarouselScan(row);
        if (window.sharedFunctions && window.sharedFunctions.setLocalStorageProductForWishlist) {
          window.sharedFunctions.setLocalStorageProductForWishlist();
        }
      })
      .catch(function () {
        // A secondary enhancement should never erase cards already rendered.
        if (row.querySelector('.product')) {
          row.removeAttribute('data-spike-deferred-home-row');
          if (window.spikeProductCarouselScan) window.spikeProductCarouselScan(row);
        } else {
          fallback(row);
        }
        delete row.dataset.spikeHomeLoading;
      });
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    }, { rootMargin: '400px 0px' });
    rows.forEach(function (row) { observer.observe(row); });
  } else {
    rows.forEach(load);
  }
}());
